<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
				
				<FormItem label="商品名称" prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入名称" disabled></Input>
				</FormItem>
				<FormItem label="数量" prop="number" class="sj">
					<Input v-model="formValidate.number" placeholder="请输入名称"></Input>
				</FormItem>
				<FormItem label="选择类型" prop="type" class="sj">
					<Select v-model="formValidate.type" placeholder="请选择类型状态">
						<Option value="STOCK">入库</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					name: '',
					remark:'',
					type: 'STOCK',
					operComMerchandise:{//商品信息
						id:""
					}
				},
				ruleValidate: {
					name: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					number: [{
						required: true,
						message: '数量不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() {//返回上一页
				this.$router.go(-1)
			},
			 handleSubmit (name) {
				 let _this=this
                this.$refs[name].validate((valid) => {
                    if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/oper/com/inventory/add',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('入库成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
                        
                    } else {
                        this.$Message.error('请完善信息后再进行提交!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            }
		},
		created() {
			let id=this.$route.query.id
			let name=this.$route.query.name
			this.formValidate.operComMerchandise.id=id
			this.formValidate.name=name
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/repertory/add.vue